export const HEADING_1_COMMON_STYLES: { [key: string]: string } = {
  margin: '0 0 8px',
  padding: '0',
  'font-size': 'var(--heading-1-font-size, 40px)',
  'font-family': 'var(--heading-1-font-family, "Helvetica Neue")',
  color: 'var(--heading-1-color, #289fe7)',
};

export const HEADING_2_COMMON_STYLES: { [key: string]: string } = {
  margin: '0 0 8px',
  padding: '0',
  'font-size': 'var(--heading-2-font-size, 36px)',
  'font-family': 'var(--heading-2-font-family, "Helvetica Neue")',
  color: 'var(--heading-2-color, #289fe7)',
};

export const HEADING_3_COMMON_STYLES: { [key: string]: string } = {
  margin: '0 0 8px',
  padding: '0',
  'font-size': 'var(--heading-3-font-size, 32px)',
  'font-family': 'var(--heading-3-font-family, "Helvetica Neue")',
  color: 'var(--heading-3-color, #289fe7)',
};

export const HEADING_4_COMMON_STYLES: { [key: string]: string } = {
  margin: '0 0 8px',
  padding: '0',
  'font-size': 'var(--heading-4-font-size, 28px)',
  'font-family': 'var(--heading-4-font-family, "Helvetica Neue")',
  color: 'var(--heading-4-color, #289fe7)',
};

export const HEADING_5_COMMON_STYLES: { [key: string]: string } = {
  margin: '0 0 8px',
  padding: '0',
  'font-size': 'var(--heading-5-font-size, 24px)',
  'font-family': 'var(--heading-5-font-family, "Helvetica Neue")',
  color: 'var(--heading-5-color, #289fe7)',
};

export const HEADING_6_COMMON_STYLES: { [key: string]: string } = {
  margin: '0 0 8px',
  padding: '0',
  'font-size': 'var(--heading-6-font-size, 20px)',
  'font-family': 'var(--heading-6-font-family, "Helvetica Neue")',
  color: 'var(--heading-6-color, #289fe7)',
};

export class HeadingWidgetData {
  // innerHtml?: string = `<h1 style="${Object.entries(HEADING_1_COMMON_STYLES).reduce((acc, [name, value]) => {
  //   return acc + `${name}:${value};`;
  // }, '')}">This is a new Heading.</h1>`;
  innerHtml?: string = '<h1> This is a new Heading.</h1>';
}

export class Heading1TextWidgetData {
  innerHtml?: string =
    '<h1 style="font-family: \'Open Sans\', sans-serif; font-size: 54px; letter-spacing: normal; line-height: 1.4; color: #091D45; text-align: center;">Heading 1</h1>\n';
}

export class Heading2TextWidgetData {
  innerHtml?: string =
    '<h2 style="font-family: \'Open Sans\', sans-serif; font-size: 36px; letter-spacing: normal; line-height: 1.4; color: #091D45; text-align: center;">Heading 2</h2>\n';
}

export class Heading3TextWidgetData {
  innerHtml?: string =
    '<h3 style="font-family: \'Open Sans\', sans-serif; font-size: 24px; letter-spacing: normal; line-height: 1.4; color: #091D45; text-align: center;">Heading 3</h3>\n';
}

export class Heading4TextWidgetData {
  innerHtml?: string =
    '<h4 style="font-family: \'Open Sans\', sans-serif; font-size: 18px; letter-spacing: normal; line-height: 1.4; color: #091D45; text-align: center;">Heading 4</h4>\n';
}
